export { default as KbSnippet } from './result-kb-snippets';
